import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, ZapIcon, ShoppingBasketIcon } from 'lucide-react';
import { Button } from '../ui/Button';
import { HERO_MOCKUP } from '../../data/content';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function Hero() {
  return <section className="relative pt-24 pb-12 md:pt-28 md:pb-16 overflow-hidden" data-id="element-117" data-mp="vmm5tzx3dmga">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[700px] h-[500px] bg-pistachio-200/50 rounded-full blur-[120px] pointer-events-none" data-id="element-118" data-mp="10lfixr8gvbfx" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-119" data-mp="15ltewawsmuxl">
        <motion.div className="max-w-4xl mx-auto text-center" variants={containerVariants} initial="hidden" animate="visible" data-id="element-120" data-mp="1ajd425v14s4b">
          <motion.div variants={itemVariants} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-surface border border-line text-sm font-medium text-pistachio-800 mb-5" data-id="element-121" data-mp="9ou9fy15exwz">
            <span aria-hidden="true" data-id="element-122" data-mp="3vu95fda2m6hb">🌿</span> CLOSE THE GAP™
          </motion.div>

          <motion.h1 variants={itemVariants} className="font-display font-bold text-ink mb-1 text-balance text-4xl sm:text-5xl md:text-6xl" style={{
          fontSize: "32px",
          paddingBottom: "38px",
          height: "120px"
        }} data-id="element-123" data-mp="3rtxks0hpk65u">
            Tu semana de comida. Resuelta. Desde hoy.
          </motion.h1>

          <motion.div variants={itemVariants} className="mb-2" data-id="element-124" data-mp="infsrveg2gyt">
            <div className="relative mx-auto w-full max-w-2xl md:max-w-3xl" data-id="element-125" data-mp="en5kud73dghb">
              <img src={HERO_MOCKUP} alt="Mega Pack Cocina Lista — 6 Tomos, 6 Bonos y el Método Cocina Impecable de Close The Gap" className="relative w-full h-auto max-h-[62vh] object-contain mx-auto drop-shadow-xl" loading="eager" style={{
              height: "280px",
              paddingTop: "0px",
              paddingBottom: "56px",
              width: "346px"
            }} data-id="element-126" data-mp="el2xk0xbq1ga" />
            </div>
          </motion.div>

          <motion.p variants={itemVariants} className="text-lg md:text-xl text-muted mb-6 max-w-3xl mx-auto text-balance" data-id="element-127" data-mp="2qwnn2yjwv0ap">
            El sistema completo de batch cooking Come bien, gasta menos y recupera tus domingos
          </motion.p>

          <motion.div variants={itemVariants} className="flex flex-wrap justify-center gap-3 mb-8" style={{
          gap: "8px"
        }} data-id="element-128" data-mp="2htuv0t2wmkjt">
            <Badge icon={<FileTextIcon size={16} data-id="element-130" data-mp="27xi4g42nomta" />} text="100% PDF" data-id="element-129" data-mp="27x9qe8usrbgi" />
            <Badge icon={<ZapIcon size={16} data-id="element-132" data-mp="27zmfd5yz2m32" />} text="Acceso en 5 min" data-id="element-131" data-mp="27z2zrvwso9s7" />
            <Badge icon={<ShoppingBasketIcon size={16} data-id="element-134" data-mp="2cwuxx7o18s4u" />} text="Ingredientes de casa" data-id="element-133" data-mp="2cx4e63j9zkxc" />
          </motion.div>

          <motion.div variants={itemVariants} className="flex flex-col items-center gap-4" data-id="element-135" data-mp="66eor0dwsi1v">
            <Button size="xl" href="#pricing" className="w-full sm:w-auto px-12" data-id="element-136" data-mp="b3ol6zzpttz7">
              <span aria-hidden="true" className="mr-2" style={{
              textAlign: "left"
            }} data-id="element-137" data-mp="1vo26uc3jv5mi">
                🛒
              </span>{' '}
              → QUIERO MI MEGA PACK AHORA
            </Button>
            <p className="text-xs text-muted flex flex-wrap justify-center items-center gap-2" data-id="element-138" data-mp="25eempr0f6amb">
              <span aria-hidden="true" data-id="element-139" data-mp="20kiul56u7hz2">🛡️</span> Garantía 7 días{' '}
              <span className="text-pistachio-300" data-id="element-140" data-mp="2ecqp0qanewul">·</span>{' '}
              <span aria-hidden="true" data-id="element-141" data-mp="2efcribiomm5y">🔒</span> Pago seguro{' '}
              <span className="text-pistachio-300" data-id="element-142" data-mp="2abdfa54fq9ie">·</span>{' '}
              <span aria-hidden="true" data-id="element-143" data-mp="2oc7ogpzb4ei4">💳</span> Mercado Pago
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}
function Badge({
  icon,
  text
}: {
  icon: React.ReactNode;
  text: string;
}) {
  return <div className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-surface border border-line text-xs font-medium text-pistachio-800" style={{
    paddingLeft: "10px",
    paddingRight: "0px",
    gap: "8px",
    width: "108px",
    height: "54px"
  }} data-id="element-144" data-mp="ty6t4f2yu9ms">
      <span className="text-pistachio-600" aria-hidden="true" data-id="element-145" data-mp="veu2k6u64fkv">
        {icon}
      </span>
      <span style={{
      width: "59px",
      height: "43px",
      textAlign: "left"
    }} data-id="element-146" data-mp="vgnadpgip5ug">{text}</span>
    </div>;
}